import { render } from "./Outlet.vue?vue&type=template&id=5e265e41&scoped=true"
import script from "./Outlet.vue?vue&type=script&lang=js"
export * from "./Outlet.vue?vue&type=script&lang=js"

import "./Outlet.vue?vue&type=style&index=0&id=5e265e41&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e265e41"]])

export default __exports__